import { Button } from '@nesso/ui/primitives/button';

import type { SelectedClient } from '@/entities/client';
import { openAddClientContactSheet } from '@/features/client/add-client-contact';

type Props = {
    client: SelectedClient | undefined;
};

export function ClientDetailsContactsAddButton({ client }: Props) {
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={!client}
            onClick={() => client && openAddClientContactSheet(client)}
        >
            Add Contact
        </Button>
    );
}
